<div class="max-width-lg services-banner">
  <app-breadcrumb class="mt-16" [items]="breadcrumbItems"></app-breadcrumb>
  <div class="flex flex-row flex-auto justify-between items-center header pb-15">
    <div class="mat-headline-1 fw-600">{{"MY_SERVICES.TITLE" | transloco}}</div>
    <div class="mat-subtitle-1 fw-400 summary mr-66">{{"MY_SERVICES.SUMMARY" | transloco}}</div>
  </div>
</div>
<div class="max-width-lg pb-130">
  <div class="flex flex-row mt-30">
    <div class="left-panel mr-24">
      <app-vertical-menu [menuItems]="verticalMenuItems" (selected)="gotoSection($event)"></app-vertical-menu>
    </div>
    <div class="right-panel">
      <div class="services-banner border p-24">
        <div class="mat-headline-4 mb-16" *ngIf="(isAllServices || isAllSandboxes) && !selectedMenuItem">{{ 'MY_SERVICES.SIDE_MENU.SERVICES.ALL' | transloco }}</div>
        <div class="mat-headline-4 mb-16" *ngIf="selectedMenuItem">{{ selectedMenuItem?.nameKey | transloco }}</div>
        <div class="flex flex-row justify-between items-center">
          <div class="mat-body-1 fw-500 mb-0 mr-200">{{ 'MY_SERVICES.IN_DEVELOPMENT_DEFINITION' | transloco }}</div>
          <button *ngIf="updatedPermissionsMap[PermissionKeys.BLUEPRINT_CREATE]" class="flex items-center mossgreen ml-140" (click)="goToComposeService()">
            <mat-icon svgIcon="add" class="icon-sm mr-10"></mat-icon>{{"COMPOSABLE_BANKING.COMPOSE_A_SERVICE" | transloco}}
          </button>
        </div>
      </div>
      <div class="flex flex-row justify-between pt-24">
        <div [ngClass]="{'disabled': loader}" clas="flex flex-row">
          <app-dropdown-fliter [filterType]="'DROPDOWN.CATEGORY'" [filterGroups]="lineOfBusinessesFilterGroups" (changed)="loadDropdownFilterCategory($event?.category)"></app-dropdown-fliter>
        </div>
        <div class="flex flex-row" *ngIf="(isServices && filteredServiceCardInfos?.length > 0) || (isSandboxes && filteredSandboxCardInfos?.length > 0)">
          <mat-icon svgIcon="grid_view" class="icon-md-1 cursor-pointer mr-18" [ngClass]="{'active' : isGridView}" (click)="switchView('grid')"></mat-icon>
          <mat-icon svgIcon="format_list_bulleted" class="icon-md-1 cursor-pointer" [ngClass]="{'active' : isListView}" (click)="switchView('list')"></mat-icon>
        </div>
      </div>
      <div *ngIf="isLoading; else showCards">
        <img src="/assets/images/icon_Microservices.svg" class="loadingimg">
        <mat-progress-bar mode="indeterminate" class="progressbar" ></mat-progress-bar>
        <div class="loadingtxt fs-16 fw-500">{{!permissionsMap[Permission.NO_SERVICES] ? ('BYOB_DASHBOARD.LOADING_SERVICES'| transloco) : ('BYOB_DASHBOARD.LOADING_SANDBOX'| transloco) }}</div>
      </div>
        <ng-template #showCards>
          <div class="flex flex-row flex-wrap pt-24 ml--12 mr--12" *ngIf="isGridView">
            <div class="flex flex-row flex-wrap">
              <ng-container *ngFor="let cardInfo of (isServices ? filteredServiceCardInfos : filteredSandboxCardInfos); let i = index;">
                <div class="pl-12 pr-12">
                  <app-card [loader]="loader" [serviceCardInfo]="cardInfo" [sandboxCardInfo]="cardInfo" [tenantDetails]="tenantDetails" class="flex mb-24 service-card-info" [style.max-width.%]="100"></app-card>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="flex flex-row flex-wrap service-card-container overflow-y-auto pt-24" *ngIf="!isGridView">
            <ng-container *ngIf="isServices; else showSandboxes">
                <app-byob-service-card *ngFor="let serviceInfo of filteredServiceCardInfos" class="w-100-percent" [loader]="loader" [serviceCardInfo]="serviceInfo"></app-byob-service-card>
            </ng-container>
            <ng-template #showSandboxes>
              <app-byob-sandbox-card *ngFor="let sandboxInfo of filteredSandboxCardInfos" class="w-100-percent" [loader]="loader" [sandboxInfo]="sandboxInfo"></app-byob-sandbox-card>
            </ng-template>
          </div>
          <div class="flex flex-col justify-center items-center" *ngIf="isServices && filteredServiceCardInfos?.length === 0 || (isServices && !filteredServiceCardInfos)">
            <img src="/assets/images/technology-and-microservices.svg" class="pt-84 pb-10">
            <span class="mat-headline-5 fw-500" *ngIf="isAllServices || isLiveServices">{{ 'MY_SERVICES.NO_ACTIVE_SERVICES' | transloco }}</span>
            <span class="mat-headline-5 fw-500" *ngIf="isInDevelopmentServices">{{ 'MY_SERVICES.NO_SERVICES' | transloco }}</span>
          </div>

          <div class="flex flex-col justify-center items-center" *ngIf="isSandboxes && filteredSandboxCardInfos?.length === 0 || (isSandboxes && !filteredSandboxCardInfos)">
            <img src="/assets/images/sandbox.svg" class="pt-84 pb-10">
            <span class="mat-headline-5 fw-500" *ngIf="isSandboxes">{{ 'MY_SERVICES.NO_ACTIVE_SANDBOXES' | transloco }}</span>
          </div>
        </ng-template>
      </div>
  </div>

</div>

